/**
 * useEffectiveUser — named hook returning the authenticated user's identity.
 *
 * Contract (Dep 5 — PRD §3.3):
 *   type EffectiveUser = { _id: string; name?: string | null; email: string };
 *   () => EffectiveUser | null
 *
 * Returns null while the auth state has not resolved or the user is
 * unauthenticated. Backed by the same `api.users.getMe` query that
 * `useCurrentUserId` consumes.
 */
import { useQuery } from "convex/react";
import { api } from "../../../../../convex/_generated/api";

export interface EffectiveUser {
  _id: string;
  name?: string | null;
  email: string;
}

export function useEffectiveUser(): EffectiveUser | null {
  const me = useQuery(api.users.getMe);
  if (!me) return null;

  return {
    _id: me._id as string,
    name: me.name ?? null,
    email: me.email ?? "",
  };
}
